import React from 'react';
import {
  ConfirmBlueLayout,
  ConfirmRegisterLayout,
  RegisterConfirmContainer,
} from '../../pages/RegisterRepresentativePage/styled';

export const RepresentativeRegisteredPage = () => {
  const currentEmail: string | null = localStorage.getItem('repRegEmail');

  return (
    <RegisterConfirmContainer>
      <ConfirmBlueLayout>Спасибо за регистрацию!</ConfirmBlueLayout>
      <ConfirmRegisterLayout>Письмо отправлено на адрес {currentEmail}.</ConfirmRegisterLayout>
      <ConfirmRegisterLayout>
        В нём содержится ссылка, по которой вы можете подтвердить свою регистрацию.
      </ConfirmRegisterLayout>
    </RegisterConfirmContainer>
  );
};
